module.exports = __webpack_public_path__ + "img/master_shift.b33f7b1b.png";